<div class="market_listing__wrapper">
  <div class="container-fluid" style="max-width: 100%;">
    <div class="row">
      <div class="col-sm-12 col-xs-12 d-lg-none d-md-none d-sm-flex d-flex filter-sort-block">
        <button class="rui-btn rui-btn--outline" disabled>
          <!-- Filter -->
            <!-- TODO enable btn and uncomment 'filter', put sortby in next btn -->
            Sort by
        </button>
        <button class="rui-btn rui-btn--outline">
          <!-- Sort -->
          <select class="form-select" [(ngModel)]="sortBy" (ngModelChange)="emitSortBy()" matNativeControl required>
            <option value="0">Popular</option>
            <option value="1">Low to High</option>
            <option value="2">High to Low</option>
          </select>
        </button>
      </div>
      <!-- Filter section -->
      <div class="col-lg-3 col-md-3 d-lg-block d-md-block d-sm-none d-none">
        <section class="filter-section">
          <h6>Filters</h6>
          <hr />
          <div class="filter-section__detail" style="width: 60%;">
            <mat-form-field appearance="fill">
              <mat-label>Sort by</mat-label>
              <select [(ngModel)]="sortBy" (ngModelChange)="emitSortBy()" matNativeControl required>
                <option value="0">Popular</option>
                <option value="1">Low to High</option>
                <option value="2">High to Low</option>
              </select>
            </mat-form-field>
          </div>
          <div class="filter-section__detail">
            <h6>Price</h6>
            <app-price-min-max-form (applyChange)="emitPriceRange($event)"></app-price-min-max-form>
          </div>
          <!-- TODO: SETUP CATEGORY FILTERING -->
          <!-- <div class="filter-section__detail">
            <h6>Category</h6>
            <ng-container *ngFor="let c of categories">
              <mat-checkbox class="example-margin" name="{{ c.source.name }}" id="cat_{{c.source.name}}"
                [(ngModel)]="c.checked" (change)="categoryChange($event)">{{
                c.source.name }}</mat-checkbox>
            </ng-container>
          </div> -->
        </section>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <div class="_Hejdi listing_wrap_results">
          <div class="result_wrap">
            <div class="listing" (click)="goToDetails(list.objectID)" *ngFor="let list of searchedListing">
              <div class="listing-item" *ngIf="list.images; else noImage"
                [ngStyle]="getBackgroundImageStyle((list.images[0] | imageUrl) | async)">
              </div>
              <ng-template #noImage>
                <div [ngStyle]="getBackgroundImageStyle(null)" class="listing-item"></div>
              </ng-template>
              <label class="title">{{ list.name }}</label>
              <label class="price">S{{ list.rentalPrice | mcp }} / day</label>
              <div *ngIf="list.averageRating" class="rating">
                <app-rating-stars-label [rating]="list.averageRating">
                </app-rating-stars-label>
              </div>
              <label class="location pin">
                <img src="../../../../assets/images/map-pin.svg" />
                {{ list.location ? list.location : 'No Location specified' }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <app-map-result class="map-result" [listings]="searchedListing"></app-map-result> -->
  </div>
</div>
<router-outlet></router-outlet>